/* eslint-disable react/forbid-dom-props */
import React, { useEffect } from 'react';
import { 
  TabIdentificacao, TabReclamante, TabReclamado, TabContrato, 
  TabJornada, TabFatosEspeciais, TabJuridico, TabValoresPedidos 
} from './tabs/AllTabs';
import '../../styles/globals.css';

export default function ImprimirFicha() {

  useEffect(() => {
    // Forçar o tema claro temporariamente na renderização para evitar fundos escuros do dark mode na impressão
    const prevTheme = document.documentElement.getAttribute('data-theme');
    document.documentElement.setAttribute('data-theme', 'light');
    
    const timer = setTimeout(() => {
      window.print();
    }, 1000);

    return () => {
      if (prevTheme) {
        document.documentElement.setAttribute('data-theme', prevTheme);
      }
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className="print-page" style={{ padding: '2rem', maxWidth: '850px', margin: '0 auto', background: '#fff', color: '#000' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', borderBottom: '2px solid var(--navy)', paddingBottom: '.5rem' }}>
        <h1 style={{ fontFamily: 'var(--font-title)', color: 'var(--navy)', margin: 0, fontSize: '1.8rem' }}>
          Peticionador<span style={{ color: 'var(--gold-dark)' }}>BR</span>
        </h1>
        <span style={{ fontSize: '.85rem', color: 'var(--text-muted)' }}>Ficha de Atendimento Trabalhista</span>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
        <section className="print-section">
          <h2 style={{ fontSize: '1.1rem', borderBottom: '1px solid #000', paddingBottom: '.25rem', marginBottom: '1rem', color: 'var(--navy)', fontWeight: 700 }}>
            1. Identificação Geral
          </h2>
          <TabIdentificacao />
        </section>

        <section className="print-section">
          <h2 style={{ fontSize: '1.1rem', borderBottom: '1px solid #000', paddingBottom: '.25rem', marginBottom: '1rem', color: 'var(--navy)', fontWeight: 700 }}>
            2. Dados do Reclamante (Trabalhador)
          </h2>
          <TabReclamante />
        </section>

        <section className="print-section">
          <h2 style={{ fontSize: '1.1rem', borderBottom: '1px solid #000', paddingBottom: '.25rem', marginBottom: '1rem', color: 'var(--navy)', fontWeight: 700 }}>
            3. Reclamado (Empresa/Empregador)
          </h2>
          <TabReclamado />
        </section>

        <section className="print-section">
          <h2 style={{ fontSize: '1.1rem', borderBottom: '1px solid #000', paddingBottom: '.25rem', marginBottom: '1rem', color: 'var(--navy)', fontWeight: 700 }}>
            4. Contrato de Trabalho
          </h2>
          <TabContrato />
        </section>

        <section className="print-section">
          <h2 style={{ fontSize: '1.1rem', borderBottom: '1px solid #000', paddingBottom: '.25rem', marginBottom: '1rem', color: 'var(--navy)', fontWeight: 700 }}>
            5. Jornada de Trabalho e Horários
          </h2>
          <TabJornada />
        </section>

        <section className="print-section">
          <h2 style={{ fontSize: '1.1rem', borderBottom: '1px solid #000', paddingBottom: '.25rem', marginBottom: '1rem', color: 'var(--navy)', fontWeight: 700 }}>
            6. Condições de Trabalho e Fatos Especiais
          </h2>
          <TabFatosEspeciais />
        </section>

        <section className="print-section">
          <h2 style={{ fontSize: '1.1rem', borderBottom: '1px solid #000', paddingBottom: '.25rem', marginBottom: '1rem', color: 'var(--navy)', fontWeight: 700 }}>
            7. Enquadramento Jurídico
          </h2>
          <TabJuridico />
        </section>

        <section className="print-section">
          <h2 style={{ fontSize: '1.1rem', borderBottom: '1px solid #000', paddingBottom: '.25rem', marginBottom: '1rem', color: 'var(--navy)', fontWeight: 700 }}>
            8. Valores Estimados dos Pedidos
          </h2>
          <TabValoresPedidos />
        </section>
      </div>

      <div className="print-actions" style={{ display: 'flex', justifyContent: 'center', marginTop: '3rem', gap: '1rem' }}>
        <button className="btn btn-primary btn-sm" onClick={() => window.print()}>Imprimir</button>
        <button className="btn btn-outline btn-sm" onClick={() => window.history.back()}>Voltar</button>
      </div>
    </div>
  );
}
